export default {
  "common":{
    "language":"简体中文",
    "MRTDataRecoveryTool":"MRT数据恢复工具",
    "latestVersion":"当前版本",
    "historicalVersions":"历史版本",
    "versionDetails":"版本详情",
    "upgradeLog":"升级日志",
    "download":"下载",
    "offline":"单机版",
    "online":"网络版",
    "changelog":"更新日志",
    "noUpgradeLog":"暂无升级日志",
    "historicalVersionsDownload":"历史版本下载",
    "viewNow":"立即查看",
    "noHistoricalVersions":"暂无历史版本",
    "Chinese":"中文",
    "English":"English",
    "collection":"收藏我们",
    "contact":"联系我们",
    "login":"登录",
    "Register":"注册",
    "home": "首页",
    "IndustryNews":"新闻中心",
    "TutorialsData": "教程资料",
    "PaidSubmission": "有偿投稿",
    "Support": "技术支持",
    "Buy": "产品购买",
    "Products": "产品专栏",
    "center": "用户中心",
    "taobao": "官方网店",
    "userCenter": "用户服务",
    "Firmware": "固件下载",
    // "siteForum": "本站论坛",
    "headlines":"最新文章",
    "UserCenter":"个人中心",
    "Click":"点击",
    "ranking":"排行",
    "Top":"热门",
    "comments":"评论",
    "IndustryTalk":"行业杂谈",
    "Tutorials":"教程",
    "wd":"西数",
    "Seagate":"希捷",
    "Hitachi":"日立",
    "Samsung":"三星",
    "Toshiba":"东芝",
    "Articles":"图文",
    "Columnist":"专栏",
    "site":"本站",
    "recommend":"推荐",
    "web":"网站",
    "bulletin":"公告",
    "Website":"产品公告",
    "Software":"软件下载",
    "Soft":"软件",
    "Categories":"所有分类",
    "Brands":"品牌",
    "Tools":"工具",
    "Author":"作者",
    "Browse":"浏览",
    "time":"发布时间",
    "Views":"点击数",
    "All":"全部",
    "Total ":"共 条",
    "previous ":"前往 页",
    "instructions":"投稿说明",
    "instructions1":"1. 欢迎大家踊跃投稿，本站鼓励原创的数据恢复与硬盘维修教程",
    "instructions2":"2. 标题和内容不可以为空",
    "instructions3":"3. 投稿后需要管理审核才会在本站发布",
    "instructions4":"4. 隐藏内容放入自定义标签  [hide] [/hide]  中，文章隐藏内容不要放在前一百字符内",
    "Column":"栏目",
    "chooseColumn":"请选择栏目",
    "chooseBrand":"请选择品牌",
    "chooseTool":"请选择工具",
    "Title":"标题",
    "Thumbnail":"缩略图",
    "Source":"文章来源",
    "Language":"语言",
    "Price":"价格",
    "USD":"美元",
    "RMB":"人民币",
    "Coins":"金币",
    "Withdraw":"提现",
    "Recharge":"充值",
    "Logout":"退出登录",
    "RechargeAccount":"账户充值",
    "RechargeMethods":"充值方式",
    "Balance":"余额",
    "amount":"充值金额",
    "toSay":"说两句吧...",
    "Comment":"发表评论",
    "hiddenContent":"隐藏内容付费可见",
    "purchase":"文章购买",
    "payment":"支付方式",
    "KeyWords":"关键字",
    "Content":"内容",
    "Submission":"投稿",
    "Ok":"确定",
    "Cancel":"取消",
    "Area":"地区",
    "Total":"文章数",
    "CommendLinks":"友情链接",
    "NavigationLink":"导航链接",
    "SiteName":"本站域名",
    "groups":"QQ交流群",
    "Terms":"使用条款",
    "Record":" 备案：鄂ICP备11013447号",
    "MRTIntroduction":"MRT数据恢复网，专业的硬盘固件维修与数据恢复技术资料提供站！",
    "collect":"您的浏览器不支持此操作,请直接使用Ctrl+D收藏本站~",
    "LearnMore":"了解更多"
  },
  "download":{
    "SoftwareDownload":"软件下载",
    "TerminalToolsDownload":"辅助工具下载",
    "PL2303Driver":"MRT新版智能USB转终端串口适配器驱动程序下载",
    "PL2303Subtitle":"PL2303;PL2303 GC",
    "DownloadDriver":"下载驱动",
    "PL2303Desc":"PL2303驱动程序适用于USB转串口适配器，提供稳定可靠的数据传输。安装后可支持多种操作系统平台，确保设备正常识别和通信。",
    "CP210xDriver":"USB转终端串口适配器驱动程序下载",
    "CP210xSubtitle":"CP210x",
    "ForWinXP":"适用于WinXP",
    "ForWin7":"适用于Win7及以上",
    "CP210xDesc":"CP210x驱动程序专为Silicon Labs的USB转UART桥接控制器设计，提供高性能的通信接口，适用于各种嵌入式设备和开发板。",
    "SATADriver":"MRT SATA均衡器驱动",
    "CH341SERDriver":"CH341SER Driver",
    "MRTChangeSignal":"MRTChangeSignal",
    "SATADesc":"适用于SATA设备的驱动程序，CH341SER用于USB转串口通信，MRTChangeSignal用于信号调节和优化。",
    "ExpandChangelog":"展开升级日志",
    "CollapseChangelog":"收起升级日志"
  },
  "products":{
    "ProductSelection":"产品选择",
    "SelectVersion":"选择版本",
    "ProductOverview":"产品概述",
    "ProductSpecifications":"产品规格",
    "SoftwareOverview":"软件概述",
    "MRTExpress":"MRT Express",
    "MRTUltra":"MRT Ultra 3.0",
    "ExpressDescription":"MRT Express是一款超值的数据恢复工具，专为数据恢复工程师设计。它支持多种硬盘的数据恢复，并提供直观的操作界面。",
    "UltraDescription":"MRT Ultra 3.0是我们的高端数据恢复解决方案，提供更强大的功能和更好的性能，适合专业数据恢复机构使用。",
    "ExpressOverview":"MRT硬件卡提供数据恢复及硬盘维修一体化方案，是处理硬盘业务的专业级固件维修工具\nMRT Express产品由硬件和软件两部分组成：\n在硬件方面，有一个特殊的MRT SATA控制器卡，配有2个SATA端口、2个电源端口、1个IDE端口，以及一些附加配件，允许同时为2块硬盘工作。\n在软件方面，MRT Express具有13+个专用磁盘修复实用程序，可在各种硬盘厂商生产的、各种不同结构和系列的硬盘上进行数据探索。\n通过先进的硬件和软件技术，可以在工厂模式下对硬盘进行访问和修复固件，还可以提取用户数据。",
    "UltraOverview":"MRT硬件卡提供数据恢复及硬盘维修一体化方案，是处理硬盘业务的专业级固件维修工具\nMRT Ultra 3.0产品由硬件和软件两部分组成：\n在硬件方面，有一个特殊的MRT SATA控制器卡，配有6个SATA端口、6个电源端口，以及一些附加配件，允许同时为6块硬盘工作。\n在软件方面，MRT Ultra 3.0具有13+个专用磁盘修复实用程序，可在各种硬盘厂商生产的、各种不同结构和系列的硬盘上进行数据探索。通过先进的硬件和软件技术，可以在工厂模式下对硬盘进行访问和修复固件，还可以提取用户数据。\nMRT Ultra 3.0可以同时控制6块硬盘，可以实现满血版的SATA 3.0 速度性能，提供六个SATA通道和电源端口，可以满足以下需求:\n- 6个盘镜像到PC端存储设备的一对一镜像操作\n- 6个超大容量机械盘的三对三镜像\n- 6个盘同时格式化操作\n- 支持6个盘的RAID阵列",
    "NetworkFullVersion":"网络完整版",
    "StandaloneFullVersion":"单机完整版",
    "StandaloneRepairVersion":"单机修盘版",
    "NetworkFullVersionDescUltra":"数据恢复及硬盘维修一体化方案。用户付首付即可得全套硬件和软件的第一个月免费试用期。 完成12/18个月的分期付款后，软件将升级为单机完整版。需要接通网络。",
    "NetworkFullVersionDescExpress":"数据恢复及硬盘维修一体化方案。用户付首付即可得全套硬件和软件的第一个月免费试用期。 完成24个月的分期付款后，软件将升级为单机完整版。需要接通网络。",
    "StandaloneFullVersionDesc":"数据恢复及硬盘维修一体化方案，用户一次性支付全款，即可终生使用软件，并且不需要接通网络。",
    "StandaloneRepairVersionDesc":"支持硬盘维修，用户一次性支付全款，即可终生使用软件，并且不需要接通网络。",
    "MRTMainInterface":"MRT主界面",
    "CommonToolsModule":"常用工具模块",
    "DataRecoveryToolModule":"数据恢复工具模块 (DE)",
    "WesternDigitalModule":"西数模块",
    "SeagateModule":"希捷模块",
    "HitachiModule":"日立/IBM/HGST—日立模块",
    "SamsungModule":"三星模块",
    "ToshibaModule":"东芝模块",
    "MaxtorModule":"迈拓模块",
    "MainInterfaceDesc":"MRT主界面提供程序的入口功能。 它采用模块扩展结构，由主程序和多个模块组成。 每个工厂程序可以提供各种功能，并定期升级。 将来可以添加新模块以实现增强功能。 MRT Express软件目前提供以下模块：\n\n通用工具，它们提供常见的功能，如磁盘扫描、ROM程序员、数据库管理工具。\n数据恢复工具，提供数据浏览器功能，如磁盘镜像、文件系统镜像等。\n西数\n希捷\n日立/IBM/HGST\n三星\n东芝\n富士通\n迈拓",
    "CommonToolsDesc":"MRT通用工具工厂程序提供常见功能，如磁盘扫描、磁盘表面测试和磁盘信息检查。",
    "DataRecoveryDesc":"MRT数据恢复工厂程序提供数据浏览器功能，例如增强的磁盘镜像、文件系统扩展等。磁盘镜像功能可以处理坏道，并且可以从具有很多坏道的硬盘拷贝数据。\n\n文件系统扩展功能可以提取目标硬盘上的所有文件。 \n\n用于拷贝磁盘的专业参数设置面板符合行业标准。 它提供单独的副本，反向拷贝和其他高级功能。 此外，它为西数、希捷和日立的独立拷贝提供完美的支持。",
    "WesternDigitalDesc":"MRT西数模块为西数硬盘提供维修功能。 其独特的\"诊断模式\"可以快速处理未出现准备就绪的硬盘（即BUSY状态为长亮）。\n\n它具有方便的固件文件夹管理功能。 对于需要处理的每个硬盘，它将为其构建一个特殊的文件夹，并且可以根据文件夹安排所有硬盘固件资源。 这使得管理固件资源非常方便。 \n\n独特的\"按轨道读取模块\"可以正确读写各种模块，市场上其他类似的产品无法做到。\n\nWDC模块列表提供了每个模块的详细信息。\n\n其独特的算术公式从SA固件区域生成ROM。 \n\n它支持使用数据库管理固件的能力。 \n\n数据库完全符合行业标准数据库格式，这意味着您可以直接从其他数据库导入固件。",
    "SeagateDesc":"MRT 希捷工厂程序包含直接读取和写入SA磁道的独特功能。这很重要，因为希捷硬盘的许多故障是由SA磁道中的数据错误引起的。市场上其他常见的希捷专业工具无法直接读取或写入SA磁道，但是MRT Express所提供的功能可以实现该步骤。 \n\nMRT的希捷工厂程序不仅允许用户读写SA磁道，而且还可以直接对SA磁道中的数据进行分析和修改。这是在希捷硬盘中处理这种故障的有效方式。同时，希捷工厂程序还包含一个独特的串口复制功能，这非常有用。例如，当希捷硬盘的ATmA接口断开并且未准备就绪时，只要用户可以进入串口，就可以复制用户的数据。此功能也可用于磁盘拷贝。它提供从希捷硬盘中提取数据的有效计划。\n\n同时，希捷程序还提供了一键修复解决方案，解决了前端部件性能好，但是终端部分在F12系列硬盘中是坏的的问题。目前，许多希捷F12硬盘有这种常见故障，可能是由于各种原因造成的。最常见的原因是由缺陷引起的表错误。对于这些类型的硬盘，希捷程序的一键修复解决方案很有可能解决它。 \n\n引导模式工具提供工作在Seagate Boot代码模式下的工具，可用于读写ROM和其他高级功能。\n\nMRT固件写入工具用于写入希捷硬盘的固件。它可以通过写入正确的固件修复由损坏的固件导致的许多故障。\n\nSA ABA读写工具可以直接读写系统LBA。它是修复服务区域的有效工具。",
    "HitachiDesc":"MRT 日立工厂程序为所有日立硬盘提供修复功能。 \n\n日立 - IBM系列 \n\nHitachi-IBM模块支持的系列具有功能对话框，包括：家族选项卡、输入模型选项、资源加载路径选项、未知家族访问方式选项、检测家族功能按钮和清除密码功能按钮。 \n\n日立 – IBM模块测试 \n\nHitachi-IBM 模块测试功能菜单包括：基本信息、子菜单、缺陷表编辑器、格式化工具，清除SMART、LDR加载程序、磁头测试、硬盘 ID编辑器、SA整体偏移选项、RAM相关操作等子菜单功能。特殊功能包括操作SA的能力，以及砍头并重新定义主头选项。 \n\n日立 – IBM模块工具 \n\n日立IBM模块工具菜单包括：固件查看器子菜单、重置和睡眠选项、逻辑扫描、CHS和LBA编辑器、数据库操作子菜单、超时参数设置、打开当前工作文件夹的功能等功能子菜单。特殊功能包括硬盘资源查看器和用户扇区查看器。\n\n日立 - ARM系列 \n\nHitachi-ARM模块程序支持的家族具有功能对话框，包括：家族选项卡、未知家族访问方式选项、加载模块列表路径选项、解锁功能按钮和检测技术密码选项。 \n\n日立 – ARM模块测试 \n\nHitachi-ARM 模块测试功能菜单包括：基本功能子菜单、格式化、缺陷表操作功能子菜单、清除SMART、重建虚拟编译器功能子菜单和RAM相关操作子菜单以及其他功能子菜单。特殊功能包括SA相关操作。 \n\n日立 – IBM模块工具 \n\n日立IBM模块工具功能菜单包括：固件查看器功能子菜单、用户扇区查看器、复位和睡眠选项、超时参数设置、数据库操作、打开当前工作文件夹和其他功能子菜单。特殊功能包括硬盘资源查看器。",
    "ToshibaDesc":"MRT东芝模块支持的家族系列含有一个对话框，包括家族选项卡和优先读写ATA操作功能的功能。 \n\n东芝模块工具 \n\n东芝模块工具功能菜单包括：固件目标查看器、复位和睡眠选项、安全子系统、CHS和LBA缺陷表编辑器、数据库操作菜单、逻辑扫描和扇区查看器、超时参数设置、打开当前工作文件夹和其他功能子菜单。 特殊功能包括读写SA轨迹的能力。 \n\n东芝模块测试\n\n东芝模块测试功能菜单包括：基本状态视图子菜单、SA操作、硬盘密码功能子菜单、显示区域表、缺陷表编辑子菜单、清除SMART、磁头测试、格式化SA的能力等菜单功能。 特殊功能包括砍头和砍断选项。",
    "MaxtorDesc":"迈拓支持的系列产品有一个功能对话框，包含一个家族选项卡和加载资源路径选项。 此外，功能按钮包括：读取设备ID、初始化固件、加载LDR、复位设备、ROM操作、重置硬盘、初始化模块等。 \n\n迈拓模块测试 \n\n迈拓模块测试功能菜单包括：基本信息子菜单、缺陷表编辑器、清除SMART和其他子菜单功能。 其特殊功能包括SA操作。 \n\n迈拓模块工具 \n\n迈拓模块工具菜单包括：固件查看器子菜单、重置和睡眠选项、超时参数设置以及打开当前工作文件夹的功能。 特殊功能包括硬盘资源查看器和用户扇区查看器。",
    "SamsungDesc":"三星模块为三星硬盘提供了修复功能。 功能菜单包括：模块列表、阅读和写入模块、读取、批量编写和备份选项、资源备份数据库支持、清除密码、清除SMART、清除ALIST、从单独磁头拷贝、读取和写入ROM选项 、在终端模式下清除\"LDE 1AXXX\"错误、检查和编辑区域表、检查和编辑默认表、最后能够下载BURN资源。",
    "FujitsuDesc":"MRT富士通模块提供富士通硬盘的维修功能。 功能菜单包括：清除代码、模块列表、读写模块、检查和编辑ROM以及检查和编辑默认表。",
    "SSDDesc":"MRTSSD模块提供SSD硬盘的数据恢复功能。 功能菜单包括：加载Loader、创建虚拟编译器。",
    "MonitoringVideoDesc":"MRT监控视频恢复工具提供海康威视H.264数据浏览器功能，例如增强的磁盘镜像、文件系统扩展等。磁盘镜像功能可以处理坏道，并且可以从具有很多坏道的硬盘拷贝数据。\n\n文件系统扩展功能可以提取目标硬盘上的所有文件。 \n\n用于拷贝磁盘的专业参数设置面板符合行业标准。 它提供单独的副本，反向拷贝和其他高级功能。 ",
    "Introduction":"介绍",
    "HardwareImages":{
      "MRTExpressSATAFront":"MRT Express SATA 控制器卡正面",
      "MRTExpressSATABack":"MRT Express SATA 控制器卡反面",
      "MRTUltraSATAFront":"MRT Ultra SATA 控制器卡正面",
      "MRTUltraSATABack":"MRT Ultra SATA 控制器卡反面",
      "SingleCoreUSBTerminal":"单核USB终端",
      "COMPortDataCable":"COM口数据线",
      "InstructionHeads":"指令头",
      "Programmer":"编程器",
      "ProgrammerCable":"编程器线",
      "PowerCables":"电源线",
      "SATACables":"SATA线",
      "USBDDataCable":"USB 数据线",
      "HardwareConnection":"硬件连接",
      "HardwareConnectionInside":"电脑内硬件连接",
      "MRTExpressSATAFrontDesc":"MRT Express SATA 控制器卡正面，显示硬盘接口和连接端口。",
      "MRTExpressSATABackDesc":"MRT Express SATA 控制器卡反面，显示硬盘接口和连接端口。",
      "MRTUltraSATAFrontDesc":"MRT Ultra SATA 控制器卡正面，显示硬盘接口和连接端口。",
      "MRTUltraSATABackDesc":"MRT Ultra SATA 控制器卡反面，显示硬盘接口和连接端口。",
      "SingleCoreUSBTerminalDesc":"单核USB终端适配器通过一端的数据线连接到计算机主机的USB接口，另一端用COM口数据线连接到硬盘。",
      "COMPortDataCableDesc":"COM口数据线用于连接硬盘的串口，进行底层调试和数据恢复操作，支持RS232标准协议。",
      "InstructionHeadsDesc":"包含8个不同类型的指令头，适用于各种接口的硬盘数据恢复，支持IDE、SATA等多种接口类型，确保在数据恢复过程中能够稳定连接硬盘。",
      "ProgrammerDesc":"MRT编程器读取和编程符合SPI接口（例如，主板BIOS芯片）的每个ROM芯片。 通过使用MRT编程器，可以将固件刷入硬盘ROM芯片或主板BIOS损坏。",
      "ProgrammerCableDesc":"专用编程器线用于连接编程器和硬盘固件接口，支持多种接口类型，确保固件数据传输稳定可靠。",
      "PowerCablesDesc":"两根高性能电源线，提供稳定的电源输出，支持12V和5V电压，适用于不同类型的硬盘设备。",
      "SATACablesDesc":"两根SATA数据线，符合SATA 3.0标准，支持6Gbps传输速率，长度0.8米，带金属屏蔽层，减少信号干扰。",
      "USBDDataCableDesc":"高速USB数据线，支持USB 3.0传输标准，确保数据传输稳定快速，长度1.5米，适合机房环境下的设备连接。"
    }
  },
  "userInfo":{
    "Personal":"个人资料",
    "avatar":"头像",
    "username":"用户名",
    "password":"密码",
    "Nickname":"昵称",
    "code":"验证码",
    "Tel":"电话",
    "QQ":"qq",
    "Email":"邮箱",
    "Balance":"余额",
    "Address":"地址",
    "longAddress":"详细地址",
    "Country":"请填写国家",
    "Province":"请填写省份",
    "City":"请填写城市",
    "avatarJpg":"上传头像图片只能是 JPG 格式!",
    "avatarSize":"上传头像图片大小不能超过 2MB!",
    "modification":"确认修改",
    "ChangePWD":"修改密码",
    "Modify":"资料修改成功！",
    "CurrentPWD":"旧密码",
    "NewPWD":"新密码",
    "confirmPWD":"确认密码",
    "Change":"修改 ",
    "Reset":"重置",
    "MyPosts":"我的投稿",
    "Date":"日期",
    "Status":"状态",
    "Views":"点击数",
    "Options":"操作",
    "Edit":"编辑",
    "Delete":"删除",
    "purchase":"购买文章"
  },
  "message":{
    "Prompt":"提示",
    "warning":"警告",
    "login":"请先登录",
    "Success":"成功",
    "CommentReview":"评论成功，审核以后可以显示",
    "SubmissionSuccess":"投稿成功，审核以后可以显示",
    "Error":"错误",
    "CurrentPassword":"请输入旧密码",
    "NewPassword":"请输入新密码",
    "pwdAgain":"请再次输入密码",
    "pwdMatch":"两次输入密码不一致!",
    "pwdDiffer":"新密码与旧密码不能一样!",
    "changeDone":"密码修改成功",
    "deleteFile":"此操作将永久删除该文件, 是否继续?",
    "Successfully":"删除成功!",
    "Successful":"成功",
    "SuccessPurchased":"购买成功",
    "Automatically":"2秒以后自动刷新页面",
    "RechargeAmount":"请填写充值金额",
    "PriceVerification":"充值金额不能小于0",
    "RechargeMethod":"请选择充值方式",
    "enterName":"请输入用户名",
    "enterPWD":"请输入密码",
    "enterCode":"请输入验证码",
    "selectColumn":"请选择文章栏目",
    "titleEmpty":"标题不能为空",
    "sourceEmpty":"文章来源不能为空",
    "chooseLanguage":"请选择语言",
    "PriceEmpty":"价格不能为空",
    "PriceZero":"价格不能小于0",
    "gologin":"注册成功，去登陆",
    "Withdraw":"提现功能暂未开放"

  },
  "home":{
    // 首页文案翻译
    "Country":"国家",
    "User":"用户",
    "Nearly":"近",
    "AlreadyHave":"已经有",
    "Two":"两个",
    "ExpressPort":"SATA2.0接口 + 一个IDE接口",
    "ExpressSupport":"支持所有IDE(CE，CF，ZIF), SATA(MICRO SATA)接口硬盘",
    "ExpressSATA":"符合SATA 2.0标准，SATA端口的速度可达",
    "ExpressIDE":"符合UDMA66标准，IDE端口速度高达",
    "Four":"六个",
    "ULTRAPort":"SATA3.0接口+六个电源端口",
    "ULTRASupport":"支持所有SATA(MICRO SATA)接口硬盘",
    "ULTRASATA":"符合SATA 3.0标准，SATA端口的速度可达",
    "ULTRAIDE":"三个PCIe 6+2pin供电接口",
    "DataRecoveryExpert":"您的数据恢复专家",
    "InnovativeSolutions":"硬盘维修和数据恢复的创新解决方案",
    "WhyChooseMRT": "为什么选择MRT？",
    "DataRecoveryTool":"一体化数据恢复工具",
    "DataRecoveryToolDes":"一体化数据恢复工具：支持各种系列硬盘的领先行业工具。配备创新和先进技术和功能，包括自动诊断功能。",
    "CustomerService":"出色的客户服务",
    "CustomerServiceDes":"优秀的客户服务：定期软件升级和技术支持服务。",
    "PaymentMethods":"灵活的支付方式",
    "PaymentMethodsDes":"灵活的支付方式：首付+分期，让您轻松购买MRT！",
    "ProfessionalDataRecovery":"专业数据恢复工具",
    "UltimateDataRecovery":"终极数据恢复工具",
    "HDDSeriesSupported":"MRT支持的硬盘系列",
    "OwnMRT":"您拥有MRT产品吗？",
    "AboutUs":"关于我们",
    "Company":"武汉思托福科技有限公司（MRT），致力于数据恢复和硬盘维修领域。",
    "CompanyMRT":"2005年MRT实验室开发了MRT的第一款软件。凭借其巧妙、科学和严谨的硬盘解剖方式，它有助于彻底改变硬盘维修领域。",
    "CompanyMRTPro":"2012年随着MRT Pro的问世，MRT开始在世界舞台上崭露头角，为全球用户提供数据恢复和硬盘维修服务，并得到了来自不同地区的优良反馈。",
    "CompanyFuture":"如今MRT实验室已发展成为世界领先的数据恢复工具供应商之一。随着全球MRT用户的日益增长，MRT实验室会一如既往致力于为每位客户提供更好服务。",
    "Year":"周年",
    "Agent":"代理商",
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/zh.js